export function getByteSize(str: string): number {
  return new TextEncoder().encode(str).length
}
